import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useRef } from 'react';
import InputWithLabel from '../../../component/common/InputWithLabel';
import {
  errorToast,
  getLocalStorageItem,
  isCopanySuperOrSubAdmin,
  isSuperAndSubAdmin,
  successToast
} from '../../../utils/helper';
import toast from 'react-hot-toast';
import Loader from '../../../component/common/Loader';
import FormSelect from '../../../component/common/FormSelect';
import { ApiForRole } from '../challenges/ApiForRole';
import { DEPARTMENT } from '../../../utils/constants';
import DraftPopup from '../../../component/common/modals/DraftPopup';
import { Api } from '../../../api';

const numberOfWinners = [
  { id: 1, name: '01', value: '01' },
  { id: 2, name: '02', value: '02' },
  { id: 3, name: '03', value: '03' },
  { id: 4, name: '04', value: '04' },
  { id: 5, name: '05', value: '05' }
];

const selectReward = [
  { id: 1, name: 'Reward', value: 1 },
  { id: 2, name: 'Wellpoints', value: 2 }
];

const initialDetailFormData = {
  _id: null,
  reward_title: '',
  number_of_winners: '',
  reward_image: '',
  reward_wellpoint: '',
  image: null,
  selectTeam: '',
  email: '',
  selectRewardType: ''
};

const TaskRewardForm = ({ data, allData, setNewChallenge, newChallenge }) => {
  const navigate = useNavigate();
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const [searchParams] = useSearchParams();
  const queryparams = Object.fromEntries(searchParams);
  const view = queryparams.view || 'edit';
  const [loader, setloader] = useState(false);
  const [deatils, setDetails] = useState({});

  // Check if fan mode is enabled
  const isFanMode = JSON.parse(getLocalStorageItem('isB2BFansMode')) || false;

  const location = useLocation();
  const state = location.state;

  const [draftPopUpOpen, setDraftPopUpOpen] = useState(false);

  const DetailsForm = () => {
    const [formData, setFormData] = useState(initialDetailFormData);
    const fileInputRef = useRef(null);
    const [imagePreview, setImagePreview] = useState('');
    const [selectedImage, setSelectedImage] = useState('');
    const [rewardData, setRewardData] = useState('');
    const [departmentList, setDepartmentList] = useState([]);
    const [answerChoices, setAnswerChoices] = useState(['']);
    const [surveyQuestionCount, setSurveyQuestionCount] = useState(1);
    const [allTeamMembers, setAllTeamMembers] = useState(false);

    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const newChallengeParam = queryParams.get('newchallenge');
      setNewChallenge(newChallengeParam);
    }, [location.search]);

    useEffect(() => {
      if (allData) {
        setDetails(allData);
      }
    }, [allData]);

    useEffect(() => {
      if (isCopanySuperOrSubAdmin()) {
        const storedEmail = localStorage.getItem('email');
        if (!storedEmail || storedEmail === 'undefined' || storedEmail === 'null') {
          return;
        }
        if (localStorage.getItem('email') !== null && localStorage.getItem('email') !== undefined) {
          if (JSON.parse(localStorage.getItem('email'))?.length > 0) {
            setAnswerChoices(JSON.parse(localStorage.getItem('email')));
            setSurveyQuestionCount(JSON.parse(localStorage.getItem('email')).length);
          } else {
            setAnswerChoices(['']);
            setSurveyQuestionCount(1);
          }
        } else {
          setAnswerChoices(['']);
          setSurveyQuestionCount(1);
        }
        if (localStorage.getItem('department')) {
          setFormData((prev) => ({
            ...prev,
            selectTeam: JSON.parse(localStorage.getItem('department'))
          }));
        }
      }
    }, []);

    const removeAnswerField = (index) => {
      if (answerChoices.length === 1) {
        errorToast('Cannot remove the last answer field');
        return;
      }
      const newAnswerChoices = answerChoices.filter((_, i) => i !== index);
      setAnswerChoices(newAnswerChoices);
      setSurveyQuestionCount(surveyQuestionCount - 1);
      setFormData((prev) => ({
        ...prev,
        email: newAnswerChoices
      }));
    };

    const addAnswerField = () => {
      setAnswerChoices([...answerChoices, '']);
      setSurveyQuestionCount(surveyQuestionCount + 1);
    };

    const handleGetQueAns = (index, e) => {
      setAnswerChoices((prev) => {
        const newAnswerChoices = [...prev];
        newAnswerChoices[index] = e.target.value;
        setFormData((prev) => ({
          ...prev,
          email: newAnswerChoices
        }));
        return newAnswerChoices;
      });
    };

    const validateEmail = (index, email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (email && !emailRegex.test(email)) {
        errorToast('Please enter a valid email address');
      }
    };

    const handleImageChange = (e) => {
      if (e?.target?.files[0]?.size > 1048576) {
        errorToast(`File size should be less than 1MB`);
      } else {
        if (e?.target?.files[0]) {
          if (!e?.target?.files[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
            errorToast(
              `The specified file ${e?.target?.files[0].name} could not be uploaded. Please upload valid image.`
            );
          } else {
            // console.log('image', e.target.files[0]);
            setSelectedImage(e.target.files[0]);
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setFormData((prev) => ({
              ...prev,
              reward_image: objectUrl,
              image: e.target.files[0]
            }));
            setImagePreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl);
          }
        } else {
          setImagePreview(undefined);
        }
      }
    };

    const handleStatusChange = async (statusID) => {
      try {
        setloader(true);
        const body = {};
        body.status = statusID;
        body.challengeId = state?._id;
        const response = await ApiForRole().updateChallengesStatus(body, state?._id);
        if (response?.status === 200) {
          toast.success(response?.data?.message);
          if (statusID === 0) {
            navigate(userData?.slug ? `/${userData?.slug}/challenges` : '/challenges');
          }
        }
      } catch (error) {
        console.error('Error fetching get wellpoints count:', error);
      } finally {
        setloader(false);
      }
    };

    // const handleChange = (e) => {
    //   const { name, value } = e.target;
    //   setFormData((prev) => ({ ...prev, [name]: value }));
    // };

    const handleChange = (e) => {
      const { name, value, max } = e.target;
      const numericValue = Number(value);
      const maxValue = Number(e.target.max);

      if (max && numericValue > maxValue) {
        return; // Prevent update if value exceeds max
      }

      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    };

    const handleContinue = async (statusID) => {
      if (statusID === 0 && !formData.image) {
        handleStatusChange(statusID);
        return;
      }
      if (!formData?.number_of_winners || (!formData?.image && !imagePreview)) {
        if (!formData?.number_of_winners) toast.error('Winners is required');
        else if (!formData?.image && !imagePreview) toast.error('Image is required');
        return;
      }
      if (isCopanySuperOrSubAdmin()) {
        const isValidEmail = (email) => {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return regex.test(email);
        };
        if (!formData?.number_of_winners || (!formData?.image && !imagePreview)) {
          if (!formData?.number_of_winners) toast.error('Winners is required');
          else if (!formData?.image && !imagePreview) toast.error('Image is required');
          return;
        }
        // Only validate emails if NOT in fan mode
        if (!isFanMode) {
          const invalidEmails = answerChoices.filter((email) => !isValidEmail(email.trim()));
          if (answerChoices && invalidEmails > 0) {
            errorToast('Please enter valid email addresses');
            return;
          }
        }
      }
      let reqBody;
      if (isCopanySuperOrSubAdmin()) {
        let emails = '';

        // Only process department and emails if NOT in fan mode
        if (!isFanMode) {
          emails = Array.isArray(formData?.email)
            ? formData.email
            : formData?.email
            ? [formData.email]
            : '';
        }
        // console.log("email", emails , formData?.email)

        reqBody = {
          challengeId: state?._id,
          numberOfWinners: formData?.number_of_winners,
          image: formData?.image || imagePreview,
          // Only include department and email if NOT in fan mode
          ...(!isFanMode && { department: formData?.selectTeam }),
          ...(!isFanMode && { email: emails.length > 0 ? emails.join(',') : '' }),
          ...(formData?.selectRewardType === 1 && { reward: formData?.reward_title }),
          ...(formData?.selectRewardType === 2 && { wellPoints: formData?.reward_wellpoint }),
          // status: statusID === 0 ? "draft" : statusID === 1 ? "publish" : "draft",
          status: 'draft',
          rewardId: formData?._id
        };
      } else if (isSuperAndSubAdmin()) {
        reqBody = {
          challengeId: state?._id,
          numberOfWinners: formData?.number_of_winners,
          image: formData?.image || imagePreview,
          // status: statusID === 0 ? "draft" : statusID === 1 ? "publish" : "draft",
          status: 'draft',
          rewardId: formData?._id,
          ...(formData?.selectRewardType === 1 && { reward: formData?.reward_title }),
          ...(formData?.selectRewardType === 2 && { wellPoints: formData?.reward_wellpoint })
        };
      }

      // console.log(reqBody, "reqbody ==>")
      try {
        setloader(true);
        await ApiForRole()
          .addChallengesReward(reqBody)
          .then((response) => {
            if (response?.status === 200) {
              successToast(response?.data?.message);
              localStorage.setItem('email', JSON.stringify(answerChoices));
              let StatusFromData = Number(localStorage.getItem('challengeStatus'));
              if (deatils?.status === 10 || deatils?.status === 11) {
                navigate(
                  userData?.slug
                    ? `/${userData?.slug}/challenges/create-new-challenges?page=preview&newchallenge=${newChallenge}`
                    : `/challenges/create-new-challenges?page=preview&newchallenge=${newChallenge}`,
                  {
                    state: {
                      _id: state?._id
                    }
                  }
                );
              } else {
                handleStatusChange(
                  statusID === 0 || statusID === 1
                    ? statusID
                    : StatusFromData === 10 || StatusFromData === 11
                    ? 11
                    : statusID
                );
                if (statusID === 0 || statusID === 1) {
                  if (newChallenge === 'true') {
                    navigate(userData?.slug ? `/${userData?.slug}/challenges` : '/challenges');
                  } else {
                    navigate(
                      userData?.slug
                        ? `/${userData?.slug}/challenges/create-new-challenges?page=results&newchallenge=${newChallenge}`
                        : `/challenges/create-new-challenges?page=results&newchallenge=${newChallenge}`,
                      {
                        state: {
                          _id: response?.data?.reward?.challengeId?._id
                        }
                      }
                    );
                  }
                } else {
                  // For Save as Template (statusID === 10), always redirect to challenges list
                  navigate(userData?.slug ? `/${userData?.slug}/challenges` : '/challenges');
                }
              }
            }
          });
      } catch (error) {
        console.error('Error fetching get wellpoints count:', error);
      } finally {
        setloader(false);
      }
    };
    const handleChange2 = (name, value) => {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    };

    const fetchDepartmentList = async (id) => {
      try {
        const response = await ApiForRole().getDepartmentList(id);
        const responseData = response?.data || {};

        if (responseData?.meta?.code === 1) {
          const convertedDepartmentList = responseData?.data?.map((department) => ({
            name: department.department_name,
            value: department.company_id
          }));
          setDepartmentList(convertedDepartmentList);
        }
      } catch (error) {
        console.error('Error fetching get wellpoints count:', error);
      } finally {
        setloader(false);
      }
    };

    useEffect(() => {
      // Only fetch department list if NOT in fan mode
      if (userData?.companyId && departmentList === null && isCopanySuperOrSubAdmin() && !isFanMode) {
        fetchDepartmentList(userData?.companyId);
      }
    }, []);

    const fetchList = async (id) => {
      try {
        const response = await ApiForRole().getChallengesReward(id);
        const responseData = response?.data?.[0] || {};
        if (responseData) {
          setRewardData(responseData);
          
          let imageFile = null;
          let imagePreviewUrl = '';

          const urlToFile = async (url, filename = 'image.jpg') => {
            try {
              const res = await fetch(url);
              const blob = await res.blob();
              return new File([blob], filename, { type: blob.type });
            } catch (error) {
              console.error('Error converting URL to file:', error);
              return null;
            }
          };

          if (responseData?.image) {
            if (responseData.image.startsWith('http')) {
              // External URL - just use directly for preview
              imagePreviewUrl = responseData.image;
              imageFile = null;
            } else {
              // Local URL - try to convert
              try {
                imageFile = await urlToFile(responseData.image);
                if (imageFile) {
                  imagePreviewUrl = URL.createObjectURL(imageFile);
                }
              } catch (error) {
                console.error('Error processing image:', error);
                imagePreviewUrl = responseData.image;
                imageFile = null;
              }
            }
          }

          setFormData({
            _id: responseData?._id,
            reward_title: responseData?.reward,
            reward_wellpoint: responseData?.wellPoints ? responseData?.wellPoints : '',
            number_of_winners: responseData?.numberOfWinners,
            reward_image: '',
            image: imageFile,
            selectTeam: responseData?.selectTeam ? responseData?.selectTeam : null,
            email: responseData?.email ? responseData?.email : null,
            selectRewardType: responseData?.reward ? 1 : responseData?.wellPoints ? 2 : null
          });

          setImagePreview(imagePreviewUrl);
          setSelectedImage(imageFile);
          setDataLoaded(true);
        }
      } catch (error) {
        console.error('Error fetching get wellpoints count:', error);
      }
    };

    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
      if (state?._id && newChallenge === 'false' && !dataLoaded) {
        fetchList(state?._id);
      }
    }, [state?._id, newChallenge, dataLoaded]);

    const handleConvertChallenges = async (statusID) => {
      // console.log(statusID, 'statusID ==> in handleConvertChallenges 1');
      const payload = {
        // ...deatils,
        status: 1,
        _id: null,
        // rewards : deatils.reward,
        rewards: deatils?.reward?.map((item) => ({
          // ...item,
          imageUrl: item.image,
          wellPoints: item.wellPoints,
          reward: item.reward,
          numberOfWinners: item.numberOfWinners,
          status: item.status
        })),
        tasks: deatils?.tasks?.map((item) => ({
          title: item.title,
          description: item.description,
          instruction: item.instruction,
          feature: item.feature,
          number_of_tries: item.number_of_tries,
          days: item.days,
          isSubscription: item.isSubscription,
          type_of_task: item.type_of_task,
          status: item.status,
          connect_to_wearable: item.connect_to_wearable,
          duration: item.duration,
          deletedAt: item.deletedAt,
          subFeature: item.subFeature
        })),
        title: deatils.title,
        description: deatils?.title,
        startDate: deatils?.startDate,
        endDate: deatils?.endDate,
        time: deatils?.time,
        imageUrl: deatils?.image,
        // Only include department and email if NOT in fan mode
        ...(!isFanMode && { department: deatils?.department }),
        ...(!isFanMode && { email: deatils?.email }),
        // tasks : deatils?.tasks,
        points: deatils?.points
      };
      // console.log(payload, 'final payload');
      try {
        setloader(true);
        const response = await ApiForRole().convertChallengesFromTemplate(payload);

        if (response?.status === 200) {
          toast.success(response?.data?.message);
          navigate(userData?.slug ? `/${userData?.slug}/challenges` : '/challenges');
        }
      } catch (error) {
        console.error('Error fetching get wellpoints count:', error);
      } finally {
        setloader(false);
      }
    };

    return (
      <div className="mt-5">
        {loader ? <Loader /> : null}
        <div className="h-full p-6 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-xl">Add reward</h3>
          </div>
          <div
            className="h-full flex flex-col md:flex-row items-start md:gap-4 gap-2 max-w-[1000px]  
          border-b-[1px] border-[#E7E8EA] pb-[20px]"
          >
            <div className="w-[82px]">
              <input
                type="file"
                accept=".jpg, .jpeg, .png"
                className="hidden"
                ref={fileInputRef}
                onChange={handleImageChange}
              />

              <div
                onClick={() => fileInputRef.current.click()}
                className="flex justify-center mt-3 items-center overflow-hidden rounded-[9px] 
                                border-[1.5px] border-[#D4D4D4] border-dashed dark:border-shoorah-darkBorder
                                 w-[82px] h-[82px] bg-[#F1F1F1] dark:bg-shoorah-darkBgColor relative cursor-pointer"
              >
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="Selected"
                    className="absolute w-full h-full object-cover rounded-[9px]"
                  />
                ) : (
                  <div className="flex flex-col justify-center items-center">
                    <svg
                      className="mb-2 text-shoorah-primary"
                      width="22"
                      height="22"
                      viewBox="0 0 23 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.89999 20.0445H14.3667C18.9222 20.0445 20.7444 18.2223 20.7444 13.6667V8.20004C20.7444 3.64449 18.9222 1.82227 14.3667 1.82227H8.89999C4.34444 1.82227 2.52222 3.64449 2.52222 8.20004V13.6667C2.52222 18.2223 4.34444 20.0445 8.89999 20.0445Z"
                        fill="#D4D4D4"
                        stroke="#0B0B0B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.90004 9.11124C9.90643 9.11124 10.7223 8.2954 10.7223 7.28902C10.7223 6.28263 9.90643 5.4668 8.90004 5.4668C7.89366 5.4668 7.07782 6.28263 7.07782 7.28902C7.07782 8.2954 7.89366 9.11124 8.90004 9.11124Z"
                        fill="#D4D4D4"
                        stroke="#0B0B0B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                        fill="#D4D4D4"
                      />
                      <path
                        d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                        stroke="#0B0B0B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                )}
              </div>
              {selectedImage && (
                <p
                  className="mt-2 text-xs text-gray-600 break-all"
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                  }}
                >
                  Selected: {selectedImage?.name} ({Math.round(selectedImage?.size / 1024)} KB)
                </p>
              )}
            </div>
            <div className="flex w-full items-end  max-w-[900px] gap-4 flex-wrap">
              <div className="flex-1 min-w-[200px]">
                <FormSelect
                  key={formData.selectRewardType}
                  label={'Select Reward Type'}
                  options={selectReward}
                  name={'selectRewardType'}
                  onChange={handleChange2}
                  value={formData?.selectRewardType || ''}
                  placeholder={'Select Reward Type'}
                  disabled={view === 'preview' || view === 'preview_only'}
                />
              </div>
              {formData?.selectRewardType === 1 && (
                <div className="flex-1 min-w-[200px]">
                  <InputWithLabel
                    label={'Reward'}
                    placeholder={'Enter Reward'}
                    containerClassName=""
                    onChange={handleChange}
                    value={formData?.reward_title}
                    name={'reward_title'}
                    disabled={view === 'preview' || view === 'preview_only'}
                  />
                </div>
              )}
              {formData?.selectRewardType === 2 && (
                <div className="flex-1 min-w-[200px]">
                  <InputWithLabel
                    label={'Wellpoints'}
                    placeholder={'Reward Wellpoints'}
                    type="number"
                    containerClassName=""
                    onChange={handleChange}
                    value={formData?.reward_wellpoint}
                    max={1000000}
                    name={'reward_wellpoint'}
                    disabled={view === 'preview' || view === 'preview_only'}
                  />
                </div>
              )}
              <div className="flex-1 min-w-[200px]">
                <InputWithLabel
                  label={'Winners'}
                  placeholder={'No. of winners'}
                  type="number"
                  containerClassName=""
                  onChange={handleChange}
                  value={formData?.number_of_winners || ''}
                  max={9999999}
                  name={'number_of_winners'}
                  disabled={view === 'preview' || view === 'preview_only'}
                />
              </div>
            </div>
          </div>
        </div>

        {isSuperAndSubAdmin() || isFanMode ? (
          ''
        ) : (
          <div className="mt-5 h-full p-6 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
            <div className="h-full flex flex-col md:flex-row items-start md:gap-4 gap-2 max-w-[800px] pb-[14px]">
              <div className="flex w-full items-end md:h-[92px] gap-4 flex-wrap">
                <div className="flex-1 w-full">
                  <FormSelect
                    key={formData.selectTeam}
                    label={'Select Team'}
                    options={departmentList}
                    name={'selectTeam'}
                    onChange={handleChange2}
                    value={formData?.selectTeam || ''}
                    placeholder={'Select Team(s)'}
                    disabled={view === 'preview' || view === 'preview_only'}
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                id="allStaff"
                name="all_staff_members"
                checked={allTeamMembers}
                onChange={(e) => {
                  setAllTeamMembers(e.target.checked);
                  setAnswerChoices(['']);
                  setSurveyQuestionCount(1);
                  localStorage.setItem('email', JSON.stringify(['']));
                }}
                disabled={view === 'preview' || view === 'preview_only'}
                className="mr-2 h-4 w-4"
              />
              <label htmlFor="allStaff" className="text-sm font-medium text-gray-700">
                All Staff Members
              </label>
            </div>
            <h3 className="font-medium text-[14px] ms-2 mb-3">Add Email</h3>
            <div className="flex-1 max-w-[800px] grid grid-cols-12 sm:gap-4 sm:w-[100%] w-full mb-6">
              {answerChoices?.map((choice, index) => (
                <div key={index} className="col-span-12 sm:col-span-10 mb-3 sm:mb-0">
                  <div className="flex items-center justify-between gap-5">
                    <div className="input-field w-full">
                      <input
                        className="w-full h-10 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:text-shoorah-darkBg dark:border-shoorah-darkBorder focus:outline-none border-[1.5px] text-[14px] border-shoorah-borderGray rounded-[8px] px-4 flex flex-col justify-center items-start relative"
                        type="text"
                        placeholder={'Enter email address'}
                        name="options"
                        autoComplete="off"
                        value={choice || ''}
                        disabled={allTeamMembers}
                        onChange={(e) => handleGetQueAns(index, e)}
                        onBlur={(e) => validateEmail(index, e.target.value)}
                        // readOnly={
                        //   surveyQuestionData.hasOther === choice.value ||
                        //   surveyQuestionData.nonAbove === choice.value
                        //     ? true
                        //     : false
                        // }
                      />
                    </div>
                    <div className="flex gap-[10px]">
                      <button
                        className="flex justify-center items-center"
                        onClick={addAnswerField}
                        disabled={allTeamMembers}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                            stroke="#A1A1A1"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M8 12H16"
                            stroke="#A1A1A1"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 16V8"
                            stroke="#A1A1A1"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      <button
                        className="flex justify-center items-center"
                        disabled={allTeamMembers}
                        onClick={() => {
                          if (surveyQuestionCount > 1) {
                            removeAnswerField(index);
                          }
                        }}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.92 22C17.42 22 21.92 17.5 21.92 12C21.92 6.5 17.42 2 11.92 2C6.41998 2 1.91998 6.5 1.91998 12C1.91998 17.5 6.41998 22 11.92 22Z"
                            stroke="#A1A1A1"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.91998 12H15.92"
                            stroke="#A1A1A1"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-end mt-6">
          {isSuperAndSubAdmin() && (
            <div className="mr-3 self-center">
              <button
                type="button"
                onClick={() => {
                  handleContinue(10);
                }}
                className="text-sm px-5 h-[40px] rounded-full border border-[#0B1D2E] bg-[#f4f4f4] text-[#0B1D2E]"
              >
                Save as Template
              </button>
            </div>
          )}
          <button
            onClick={() => handleContinue(0)}
            type="button"
            className="btn-primary btn-sm w-full sm:w-auto me-2"
          >
            Save Draft
          </button>
          {deatils?.status === 10 || deatils.status === 11 ? (
            <button
              onClick={() => handleContinue(1)}
              type="button"
              className="btn-primary btn-sm w-full sm:w-auto"
            >
              Preview
            </button>
          ) : (
            <button
              // onClick={() => handleContinue(1)}
              onClick={() => {
                if (deatils?.status === 10 || deatils?.status === 11) {
                  handleConvertChallenges(1);
                } else {
                  handleContinue(1);
                }
              }}
              type="button"
              className="btn-primary btn-sm w-full sm:w-auto"
            >
              Publish Challenge
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <DetailsForm />
    </div>
  );
};

export default TaskRewardForm;
